import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecab() {



const cardData = {
  keyword: " Mumbai Airport to Pune Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers track flight arrivals, provide punctual pickups from the airport, and ensure a convenient ride from Mumbai Airport to Pune. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport to Pune cab travel.",

topPlaces: [
 
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fortress located on the outskirts of Pune, known for its scenic views and Maratha history. Travelers arriving from Mumbai Airport by cab often include this destination for trekking and enjoying breathtaking landscapes."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of the most revered temples in Pune dedicated to Lord Ganesha. Visitors traveling from Mumbai Airport by cab frequently stop here to seek blessings and experience the spiritual atmosphere."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, located in the heart of Pune. Travelers using a Mumbai Airport to Pune cab can visit this peaceful historical site known for its unique architecture."
  },
   {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Travelers using a Mumbai Airport to Pune cab often visit this landmark to explore its grand gates, historical ruins, and cultural significance."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most important historical landmarks associated with India’s freedom movement and Mahatma Gandhi. Visitors traveling from Mumbai Airport by cab can explore its elegant architecture, peaceful gardens, and museum."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a remarkable collection of Indian artifacts including sculptures, musical instruments, and decorative items. Visitors from Mumbai Airport can explore Pune’s rich cultural heritage through this museum."
  },
  {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is one of the oldest heritage sites in Pune offering panoramic views of the city. Travelers arriving from Mumbai Airport by cab often climb the hill to enjoy scenic beauty and visit the historic temples."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a popular getaway near Pune known for its serene water views and surrounding hills. Travelers from Mumbai Airport often visit this relaxing spot for photography and peaceful sunsets."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a beautifully designed Japanese-style garden. Visitors traveling from Mumbai Airport by cab can enjoy its calm atmosphere, walking paths, and lush greenery."
  },
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace associated with the childhood of Chhatrapati Shivaji Maharaj. Travelers using a Mumbai Airport to Pune cab can visit this important landmark to learn about Pune’s rich Maratha history."
  }
],



services: [
{
name: "Mumbai to Pune Cab Service",
description: "Mumbai to Pune cab service provides reliable intercity transportation between Mumbai and Pune via the Mumbai–Pune Expressway. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel. Professional drivers offer punctual pickup from homes, hotels, offices, and airport terminals across Mumbai."
},
{
name: "Mumbai Airport Terminal 2 to Pune Cab",
description: "Mumbai Airport Terminal 2 to Pune cab service offers convenient airport transfers from Chhatrapati Shivaji Maharaj International Airport Terminal 2 to Pune city. Spacious vehicles with luggage space ensure comfortable airport travel."
},
{
name: "Mumbai Airport to Pune Cab Fare",
description: "Mumbai Airport to Pune cab fare service provides transparent pricing for passengers traveling from Mumbai Airport to Pune. Travelers can choose sedan, Ertiga, or Innova vehicles depending on their comfort needs."
},
{
name: "Pune to Mumbai Airport Cab Price",
description: "Pune to Mumbai Airport cab price service offers clear fare estimates for travelers heading to Mumbai Airport terminals. Professional drivers ensure timely pickup and safe expressway journeys."
},
{
name: "Mumbai International Airport to Pune Cab",
description: "Mumbai International Airport to Pune cab service provides dependable transportation between Mumbai Airport and Pune city. Comfortable vehicles ensure relaxed highway travel."
},
{
name: "Mumbai Airport Pune Taxi Service",
description: "Mumbai Airport Pune taxi service offers reliable intercity taxi transportation between Mumbai Airport and Pune. Vehicles are suitable for airport transfers and long-distance travel."
},
{
name: "Mumbai Airport to Pune Cab Charges",
description: "Mumbai Airport to Pune cab charges service provides detailed fare information for airport transfer travel between Mumbai Airport and Pune."
},
{
name: "Mumbai Airport to Pune Cab Service",
description: "Mumbai Airport to Pune cab service provides convenient airport transfers with comfortable vehicles and professional drivers ensuring safe expressway travel."
},
{
name: "Mumbai Airport to Pune Car Hire",
description: "Mumbai Airport to Pune car hire service offers comfortable vehicle rental with drivers for airport transfer journeys between Mumbai and Pune."
},
{
name: "Mumbai Airport to Pune Innova",
description: "Mumbai Airport to Pune Innova service offers spacious SUV transportation ideal for families and business travelers with luggage traveling from the airport to Pune."
},
{
name: "Mumbai Airport to Pune Taxi Online Booking",
description: "Mumbai Airport to Pune taxi online booking allows passengers to reserve taxis easily for airport transfers with flexible booking options and comfortable vehicles."
},
{
name: "Mumbai International Airport to Pune Cab Service",
description: "Mumbai International Airport to Pune cab service provides dependable long-distance travel from the airport to Pune city with comfortable vehicles."
},
{
name: "Mumbai Pune Airport Cab",
description: "Mumbai Pune airport cab service offers reliable intercity airport transportation between Pune and Mumbai Airport terminals."
},
{
name: "Mumbai Airport to Pune Innova Crysta Cab",
description: "Mumbai Airport to Pune Innova Crysta cab service offers premium SUV travel with spacious seating and comfortable highway journeys."
},
{
name: "Mumbai Airport to Pune Ertiga Cab",
description: "Mumbai Airport to Pune Ertiga cab service provides economical 7-seater transportation suitable for small groups and family travel."
},
{
name: "Mumbai Airport Cab Service",
description: "Mumbai Airport cab service provides reliable airport transportation for pickups and drops across Mumbai city and nearby destinations."
},
{
name: "Mumbai Airport Car Rental",
description: "Mumbai Airport car rental offers convenient vehicle hire for passengers traveling from the airport to city destinations or nearby cities like Pune."
},
{
name: "Airport Taxi Mumbai",
description: "Airport taxi Mumbai provides dependable airport transportation with comfortable vehicles and experienced drivers ensuring timely pickups."
},
{
name: "Mumbai Airport Transfer",
description: "Mumbai airport transfer service provides convenient pickup and drop transportation for passengers traveling through Mumbai Airport."
},
{
name: "Mumbai Airport Taxi",
description: "Mumbai airport taxi service offers reliable transportation for airport arrivals and departures with comfortable vehicles."
},
{
name: "Mumbai Airport Taxi Booking",
description: "Mumbai airport taxi booking allows passengers to easily reserve taxis for airport pickups and drops with flexible scheduling options."
},
{
name: "Mumbai Airport Cab Service",
description: "Mumbai airport cab service offers dependable airport transportation across Mumbai and nearby cities including Pune."
},
{
name: "Mumbai Airport Outstation Taxi",
description: "Mumbai airport outstation taxi provides comfortable long-distance transportation from Mumbai Airport to cities like Pune, Nashik, and Lonavala."
},
{
name: "Mumbai Airport to Hinjewadi Taxi Fare",
description: "Mumbai Airport to Hinjewadi taxi fare service provides affordable pricing for travelers heading from the airport to Pune’s IT hub Hinjewadi."
},
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai Airport to Pune cab service offers reliable airport transfers between Mumbai Airport and Pune city with comfortable vehicles and experienced drivers."
}
],

tableData: [
["Mumbai to Pune Cab Service","Mumbai Airport Terminal 2 to Pune Cab"],
["Mumbai Airport to Pune Cab Fare","Pune to Mumbai Airport Cab Price"],
["Mumbai International Airport to Pune Cab","Mumbai Airport Pune Taxi Service"],
["Mumbai Airport to Pune Cab Charges","Mumbai Airport to Pune Cab Service"],
["Mumbai Airport to Pune Car Hire","Mumbai Airport to Pune Innova"],
["Mumbai Airport to Pune Taxi Online Booking","Mumbai International Airport to Pune Cab Service"],
["Mumbai Pune Airport Cab","Mumbai Airport to Pune Innova Crysta Cab"],
["Mumbai Airport to Pune Ertiga Cab","Mumbai Airport Cab Service"],
["Mumbai Airport Car Rental","Airport Taxi Mumbai"],
["Mumbai Airport Transfer","Mumbai Airport Taxi"],
["Mumbai Airport Taxi Booking","Mumbai Airport Cab Service"],
["Mumbai Airport Outstation Taxi","Mumbai Airport to Hinjewadi Taxi Fare"],
["Mumbai Airport to Pune Cab","Mumbai to Pune Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly handle Mumbai Airport to Pune transfers. Their knowledge of airport terminals, pickup points, and expressway routes ensures smooth and timely travel."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mumbai Airport to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Airport Pickup Service",
    WhyChoosedescription: "Our Mumbai Airport to Pune cab service operates 24 hours a day. Whether your flight arrives early morning or late night, Velocity Cabs ensures reliable airport transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance airport transfer experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way airport drop, round-trip bookings, business travel, and customized travel plans from Mumbai Airport to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Direct Airport Pickup",
    WhyChoosedescription: "Our drivers provide direct pickup from all terminals of Mumbai Airport including Terminal 1 and Terminal 2, ensuring a hassle-free travel experience for passengers heading to Pune."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and reliable airport transfer service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai Airport to Pune?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai Airport to Pune with professional drivers and comfortable vehicles." },
  { question: "Is Mumbai Airport to Pune cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival schedules." },
  { question: "Which vehicles are available for Mumbai Airport to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mumbai Airport to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Mumbai Airport and Pune." },
  { question: "Do drivers wait if my flight is delayed?", answer: "Yes, our drivers track flight arrival times and coordinate with passengers for smooth pickup even if the flight is delayed." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai Airport to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service anywhere in Pune?", answer: "Yes, Velocity Cabs provides doorstep drop services across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, and Pimpri Chinchwad." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback:
      "Smooth pickup from Mumbai Airport made the Pune journey very comfortable. The cab was clean, and the long drive felt relaxed and well-managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Deshmukh",
    feedback:
      "A hassle-free travel experience from Mumbai Airport to Pune. The vehicle was well-maintained, and the ride quality made the entire trip feel easy and safe.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Mumbai Airport to Pune cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Ertiga, and Sedan cabs for airport transfers, corporate trips, and city-to-city travel. Enjoy safe, comfortable, and punctual rides with easy online booking from Mumbai Airport (Terminal 1 & 2) to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Innova, Ertiga & Sedan for Terminal 1 & 2, corporate trips & city-to-city travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecab;